import TruncatedTextTooltip from "components/pages/schedule/workOrderCards/TruncatedTextTooltip";

function getTooltipProps(label) {
  return {
    maxWidth: 200,
    showDelay: 500,
    tooltip: TruncatedTextTooltip({ label }),
  };
}

export { getTooltipProps };
